import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';
import PortalShell from '../components/PortalShell.jsx';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  const { t } = useLanguage();

  return (
    <PortalShell width="narrow">
      <div className={styles.wrapper}>
        <p className={styles.title}>{t('notFound.title')}</p>
        <p className={styles.body}>{t('notFound.body')}</p>
        <Link to="/" className={styles.link}>
          {t('portal.login.backToLanding')}
        </Link>
      </div>
    </PortalShell>
  );
}
